import { useEffect, useState } from "preact/hooks";
import { postError } from "@/lib/api_controller";

export default function StripeCheckoutHandler() {
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchSessionData = async () => {
      try {
        const urlParams = new URLSearchParams(window.location.search);
        const stripeSessionId = urlParams.get("session_id");
        const cancelled = urlParams.get("cancelled") ?? false;

        // Redirect to the return URL with the success parameter
        const encodedReturnUrl = urlParams.get("return_url");
        let returnUrl = decodeURIComponent(encodedReturnUrl);
        returnUrl = `${returnUrl}?payment_return_success=${!cancelled}`;
        if (!cancelled) {
          returnUrl = `${returnUrl}&stripe_session_id=${stripeSessionId}`;
        }
        window.location.href = returnUrl;
      } catch (error) {
        const msg = "Error in stripeCheckoutHandler.fetchSessionData()";
        console.error(msg, error);
        postError(msg, error);
        setError(msg);
      }
    };

    fetchSessionData();
  }, []);

  if (error) return <div>{error}</div>;
  return <div>...</div>;
}
